// @mui
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

// A component, not a plain style builder: it uses `useTheme`, so it has to be
// rendered as one. `LoadingScreen` used to call it as a function and discard the
// element it returned, which meant these overrides never reached the document.
export default function NProgressStyle() {
  const theme = useTheme();

  const inputGlobalStyles = (
    <GlobalStyles
      styles={{
        '#nprogress': {
          pointerEvents: 'none',
          '& .bar': {
            top: 0,
            left: 0,
            height: 2,
            width: '100%',
            position: 'fixed',
            zIndex: theme.zIndex?.snackbar,
            backgroundColor: theme.palette?.primary.main,
            boxShadow: `0 0 2px ${theme.palette?.primary.main}`
          },
          '& .peg': {
            right: 0,
            opacity: 1,
            width: 100,
            height: '100%',
            display: 'block',
            position: 'absolute',
            transform: 'rotate(3deg) translate(0px, -4px)',
            boxShadow: `0 0 10px ${theme.palette?.primary.main}, 0 0 5px ${theme.palette?.primary.main}`
          }
        },
      }}
    />
  );

  return inputGlobalStyles;
}
